// ─── Domain enumerations ────────────────────────────────────────────────────

export const VIZUALISATION = [
  "DONUT",
  "LINE",
  "BAR",
  "STACKED_BAR",
  "FUNNEL",
  "BUBBLE",
  "TABLE",
  "BARCODE",
  "DIFFERENTIATION",
  "BUTTERFLY",
  "PERCEPTUAL",
  "PROFILE",
] as const;
export type VISUALISATION_TYPE = (typeof VIZUALISATION)[number];

export const MODES = ["TREND", "POINT_IN_TIME", "PRE_POST", "PROFILE"] as const;
export type MODE_TYPES = (typeof MODES)[number];

export const BASES = [
  "GENPOP",
  "RQ_GENPOP",
  "FAMILIAR",
  "ADRECALL",
  "USER",
  "AWARE",
] as const;
export type BASES_TYPES = (typeof BASES)[number];

export const PERIODS = [
  "P_W",
  "P_M",
  "P_Q",
  "MV_1",
  "MV_2",
  "MV_4",
  "MV_8",
  "MV_12",
] as const;
export type PERIOD_TYPES = (typeof PERIODS)[number];

// ─── Trends-metric base overrides ───────────────────────────────────────────

/**
 * When the analytical mode is TREND, certain trends metrics restrict which
 * respondent bases are valid. Add an entry here keyed by either
 * `${module.toUpperCase()}_${userSelection.trendsMetric}` or `userSelection.trendsMetric`
 * (matching the metric key exposed by the metric catalog) to declare a narrowed
 * `supportedBases` list and the corresponding `defaultBase`.
 *
 * The listener will merge these values on top of the resolved `CONFIG_SCHEMA`
 * so that `pruneInvalidFields` sees the correct base options for the selected
 * metric and resets an invalid base automatically.
 *
 * @example
 * AD_RECALL: {
 *   supportedBases: ["ADRECALL"],
 *   defaultBase: "ADRECALL",
 * },
 */
export const TRENDS_METRIC_BASE_OVERRIDES: Record<
  string,
  { supportedBases: BASES_TYPES[]; defaultBase: BASES_TYPES }
> = {
  CONVERSION_awareness: {
    supportedBases: ["GENPOP"],
    defaultBase: "GENPOP",
  },
  CONVERSION_familiarity: {
    supportedBases: ["GENPOP"],
    defaultBase: "GENPOP",
  },
  CONVERSION_usage: {
    supportedBases: ["GENPOP", "FAMILIAR"],
    defaultBase: "GENPOP",
  },
  CONVERSION_trial: {
    supportedBases: ["GENPOP", "FAMILIAR"],
    defaultBase: "GENPOP",
  },
  CONVERSION_recommend: {
    supportedBases: ["USER"],
    defaultBase: "USER",
  },
  // Add per-metric base overrides here, e.g.:
  // AD_RECALL: { supportedBases: ["ADRECALL"], defaultBase: "ADRECALL" },
};

export const MARKETS_BASE_OVERRIDES: Record<
  string,
  { supportedBases: BASES_TYPES[]; defaultBase: BASES_TYPES }
> = {
  ETSY: {
    supportedBases: ["GENPOP", "FAMILIAR", "AWARE"],
    defaultBase: "GENPOP",
  },
};
